import { render, staticRenderFns } from "./kuranTitleItem.vue?vue&type=template&id=6b507684"
import script from "./kuranTitleItem.vue?vue&type=script&lang=js"
export * from "./kuranTitleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports